
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
import { diagramToAnalyticsItem } from '@/utils/helpers'
Vue.use(VueObserveVisibility)

export default {
  transition: 'page',
  fetchOnServer: true,
  async asyncData ({ $backend, params }) {
    let ordering = 'ordering'
    if (params.tag === 'new') {
      ordering = '-refresh_date'
    }
    const { diagrams, count, next } = await $backend.diagrams.get({ tags: params.tag, ordering }).then(
      (data) => {
        return {
          diagrams: data.results,
          count: data.count,
          next: data.next
        }
      }
    )
    return { diagrams, count, next, params }
  },
  data () {
    return {
      loading: false,
      order: 'ordering',
      page: 1,
      tag: ''
    }
  },
  head () {
    return {
      title: `Presentations tagged with ${this.$route.params.tag}`,
      bodyAttrs: {
        class: 'page-category'
      }
    }
  },
  computed: {
    listName () {
      return 'Diagrams with tag ' + this.$route.params.tag
    }
  },
  mounted () {
    this.$gtag.event(
      'view_item_list', {
        items: this.diagrams.map((diagram, index) => ({
          ...diagramToAnalyticsItem(diagram, index),
          list_name: this.listName
        }))
      }
    )
  },
  methods: {
    async loadDiagrams (isVisible) {
      let ordering = 'ordering'
      if (this.$route.params.tag === 'new') {
        ordering = '-refresh_date'
      }
      if (isVisible && !this.loading && this.next) {
        this.next = null
        this.loading = true
        this.page += 1
        const response = await await this.$backend.diagrams.get({ tags: this.tag, ordering, page: this.page })
        this.loading = false
        this.next = response.next
        this.diagrams = [...this.diagrams, ...response.results]
      }
    }
  }
}
